

import templateUserProfilePage from '@/app-template/lib/pages/UserProfilePage.vue';

export default {
  name: "UserProfilePage",
  components: { templateUserProfilePage },
};
